import { Link, Typography } from '@material-ui/core';
import React from 'react';

interface Example {
  name: string;
  smiles: string;
  molFile: string;
}

const EXAMPLES: Example[] = [
  {
    name: `4-hydroxy-biphenyl`,
    smiles: `Oc2ccc(c1ccccc1)cc2`,
    molFile: `
  Mrv1729 09041912432D

 13 14  0  0  0  0            999 V2000
   -4.7098   10.1554    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.4243    9.7429    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.4243    8.9178    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7098    8.5053    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9954    8.9178    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9954    9.7429    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7098    7.6803    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.4243    7.2678    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.4243    6.4428    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7098    6.0303    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9954    6.4428    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9954    7.2678    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7098    5.2053    0.0000 O   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  1  6  2  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
  7  8  1  0  0  0  0
  7 12  2  0  0  0  0
  4  7  1  0  0  0  0
 10 13  1  0  0  0  0
M  END`,
  },
  {
    name: `5‐methylpiperidin‐3‐amine`,
    smiles: `CC1CNCC(N)C1`,
    molFile: `
  Mrv1729 09041912502D

  8  8  0  0  0  0            999 V2000
   -3.0580    1.4277    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.7725    1.0152    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.7725    0.1902    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0580   -0.2223    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3436    0.1902    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3436    1.0152    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0580    2.2527    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6291   -0.2223    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  1  6  1  0  0  0  0
  1  7  1  0  0  0  0
  5  8  1  0  0  0  0
M  END
`,
  },
  {
    name: `N‐phenyl‐1,3‐benzoxazol‐2‐amine`,
    smiles: `c3ccc(Nc2nc1ccccc1o2)cc3`,
    molFile: `
  Mrv1729 09041912492D

 16 18  0  0  0  0            999 V2000
   -1.4087   -2.8414    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8212   -2.1269    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4087   -1.4124    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5837   -1.4124    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1712   -0.6979    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.6538   -0.6979    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1387   -0.0305    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.9233   -0.2854    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6378    0.1271    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3523   -0.2854    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3523   -1.1104    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6378   -1.5229    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9233   -1.1104    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1387   -1.3654    0.0000 O   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1712   -2.1269    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5837   -2.8414    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
  8 13  1  0  0  0  0
 13 14  1  0  0  0  0
  6 14  1  0  0  0  0
  4 15  1  0  0  0  0
 15 16  2  0  0  0  0
  1 16  1  0  0  0  0
M  END
`,
  },
  {
    name: `1‐methyl‐4‐(pyrrolidine‐2‐carbonyl)piperazine`,
    smiles: `CN1CCN(CC1)C(=O)C2CCCN2`,
    molFile: `
  CDK     09191911292D

 14 15  0  0  0  0  0  0  0  0999 V2000
   -6.2737   -3.0002    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9748   -2.2500    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6748   -3.0000    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3748   -2.2500    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3748   -0.7500    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6748    0.0000    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9748   -0.7500    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0758    0.0002    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0761    1.5002    0.0000 O   0  0  0  0  0  0  0  0  0  0  0  0
    0.2233   -0.7496    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3807   -2.2374    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.8491   -2.5538    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5989   -1.2547    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5903   -0.1415    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  1  0  0  0  0
  2  7  1  0  0  0  0
  5  8  1  0  0  0  0
  8  9  2  0  0  0  0
  8 10  1  0  0  0  0
 10 11  1  0  0  0  0
 11 12  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  1  0  0  0  0
 10 14  1  0  0  0  0
M  END
`,
  },
  {
    name: `3-acetamido-4-fluorobenzoic acid`,
    smiles: `CC(=O)NC=1C=C(C=CC1F)C(=O)O`,
    molFile: `
  CDK     09191911352D

 14 14  0  0  0  0  0  0  0  0999 V2000
   -5.1970    1.5006    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8981    0.7504    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8983   -0.7496    0.0000 O   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5989    1.5002    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3000    0.7500    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0000    1.5000    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3000    0.7500    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3000   -0.7500    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0000   -1.5000    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3000   -0.7500    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5989   -1.5002    0.0000 F   0  0  0  0  0  0  0  0  0  0  0  0
    2.5989    1.5002    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5987    3.0002    0.0000 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.8981    0.7504    0.0000 O   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  2  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  5 10  2  0  0  0  0
 10 11  1  0  0  0  0
  7 12  1  0  0  0  0
 12 13  2  0  0  0  0
 12 14  1  0  0  0  0
M  END
`,
  },
  //  {
  //      name: ``,
  //      smiles: ``,
  //      molFile: ``,
  //    },
];

interface Props {
  setJSME?: (molFile: string) => void;
}

const Examples = ({ setJSME = () => {} }: Readonly<Props>) => {
  const handleExampleClick = (molFile: string) => (event: any) => {
    setJSME(molFile);
  };
  return (
    <section>
      {EXAMPLES.map((ex, index) => (
        <Typography align="left" key={`${ex}-${index}`}>
          <Link variant="subtitle2" component="button" onClick={handleExampleClick(ex.molFile)}>
            {ex.name}
          </Link>
        </Typography>
      ))}
    </section>
  );
};

export default Examples;
